import { isInIframe } from "@/features/auth/helpers/isInIframe";
import { useMenu } from "@/router/menuConfig/useMenu";

import { Menubar } from "../Menubar/Menubar";

import { LogOutItem } from "./Logout.item";

import "./navbar.css";

export function Navbar() {
  const items = useMenu();

  const endPart = () => {
    return <div className="flex gap-2">{!isInIframe() && <LogOutItem />}</div>;
  };

  return <Menubar className="mainBar" end={endPart} model={items} />;
}
